import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {
  @Input() type = '';
  @Input() shape = '';
  @Input() size = '';
  @Input() round = '';
  @Input() background = '';
  @Input() padding = '';
  @Input() disabled!:boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
